import { useDispatch, useSelector } from 'react-redux';
import { getSubjects } from 'logic/store/subject/subject.selectors';
import { useDecodedSubjectFromURI } from 'src/pages-all/search/hooks/useDecodedSubjectFromURI';
import { useEffect } from 'react';
import { navigationSlice } from 'logic/store/navigation/navigation.slice';
import { AppRoute } from 'app/app.route.const';

export const useValidSubjectOrNotFound = () => {
  const subjects = useSelector(getSubjects);
  const searchSlug = useDecodedSubjectFromURI();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      searchSlug &&
      subjects &&
      !subjects.find((subject) => subject && subject.slug === searchSlug)
    ) {
      dispatch(navigationSlice.actions.navigateTo({ path: AppRoute.NotFound }));
    }
  }, [dispatch, searchSlug, subjects]);
};
